import { formatFileSize } from '@/utils/mediaUtils'
import type { MediaPreloadProgress } from '@/services/mediaPreloader'

export function mediaCachePercent(p: MediaPreloadProgress): number {
  if (p.totalBytes > 0) return Math.min(100, Math.round((p.processedBytes / p.totalBytes) * 100))
  return p.total > 0 ? Math.round(((p.completed + p.failed) / p.total) * 100) : 0
}

export function mediaCacheLabelParams(p: MediaPreloadProgress) {
  return {
    completed: p.completed,
    total: p.total,
    processedSize: formatFileSize(p.processedBytes),
    totalSize: formatFileSize(p.totalBytes),
  }
}
